"use client";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider"; // GLOBAL CUSTOM COMPONENTS
import SalifyFallback from "src/lib/components/salify-fallback/default";
import { Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography"; // GLOBAL CUSTOM HOOK
import useCart from "src/lib/components/salify-next-layout/default/hooks/useCart"; // LOCAL CUSTOM COMPONENTS
import { useGlobalContext } from "src/lib/components/salify-next-layout/default/global-context";
import ListItem from "../list-item";
import CartItem from "./cart-item";
import { PromotionResultType } from "src/lib/fetcher/client";

const CheckoutAltSummary = () => {
  const { state } = useCart();
  const { getPrice, promotionResult } = useGlobalContext();
  const price = getPrice();
  const shippingPrice = price.shipping;
  const finalPrice = price.amount;
  const totalPrice = price.price;
  const tax = price.tax;
  const discount = price.discount;
  let label = "Phí vận chuyển";
  if (
    shippingPrice === 0 &&
    promotionResult &&
    promotionResult.code &&
    promotionResult.code.length &&
    promotionResult.resultType === PromotionResultType.FreeShipping
  ) {
    label += " (Mã vận chuyển 0 đồng) ";
  }

  return (
    <div>
      <Paragraph color="secondary.900" fontWeight={700} mb={2}>
        <SalifyFallback.Label path="Your order" default="Đơn hàng của bạn" />
      </Paragraph>

      {state.cart.map(({ product, quantity }) => (
        <CartItem name={product.name} price={product.salePrice} qty={quantity} key={product.id} />
      ))}

      <Box component={Divider} borderColor="grey.300" my={3} />

      <SalifyFallback.Label
        path="Subtotal"
        default="Tổng giá sản phẩm"
        render={(label) => <ListItem mb={1} title={label} value={totalPrice} />}
      />
      <SalifyFallback.Label
        path="Shipping"
        default={label}
        render={(label) => <ListItem mb={1} title={label} value={shippingPrice} />}
      />
      <SalifyFallback.Label
        path="Tax"
        default="Thuế"
        render={(label) => <ListItem mb={1} title={label} value={tax} />}
      />
      <SalifyFallback.Label
        path="Discount"
        default="Giảm giá"
        render={(label) => <ListItem mb={1} title={label} value={discount} />}
      />

      <Box component={Divider} borderColor="grey.300" mb={1} />

      <SalifyFallback.Label
        path="Total"
        default="Tổng giá"
        render={(label) => <ListItem mb={1} title={label} value={finalPrice} color="inherit" />}
      />
    </div>
  );
};

export default CheckoutAltSummary;
